import { render, staticRenderFns } from "./FolderItemOptions.vue?vue&type=template&id=cc967fd6&scoped=true&"
import script from "./FolderItemOptions.vue?vue&type=script&lang=js&"
export * from "./FolderItemOptions.vue?vue&type=script&lang=js&"
import style0 from "./FolderItemOptions.vue?vue&type=style&index=0&id=cc967fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc967fd6",
  null
  
)

export default component.exports